/**
 * Harness binding for the Heidi Verify root-cause sub-agent.
 */
export const ROOT_CAUSE_ANALYZER_TOOL_NAME = 'root_cause_analyzer';

export const GET_NOTE_VERIFICATION_ANALYSIS_TOOL_NAME = 'get_note_verification_analysis';

export const VERIFY_SUBAGENT_TOOL_NAMES = new Set<string>([
  ROOT_CAUSE_ANALYZER_TOOL_NAME,
]);

export const isVerifySubagentToolName = (name: string | undefined): boolean =>
  name !== undefined && VERIFY_SUBAGENT_TOOL_NAMES.has(name);

/**
 * Pull the `question` argument out of a root_cause_analyzer tool_call so the
 * inline block can show it before the child stream arrives.
 */
export const readVerifySubagentInput = (
  input: Record<string, unknown> | undefined
): { question?: string } => {
  if (!input) return {};
  const question =
    typeof input.question === 'string' && input.question.trim()
      ? input.question.trim()
      : undefined;
  return { question };
};
